import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const PlayerMyEventsSkeleton: React.FC<{}> = ({}) => {
    return (
        <div className="my-events">
            <Skeleton containerClassName={'my-events-card-skeleton'} />
            <div className="my-upcoming-events-card">
                <div className="title-container">
                    <Skeleton containerClassName={'title'} width={180} borderRadius={15} />
                </div>
                <div className="content">
                    <Skeleton height={344} borderRadius={15} />
                    <Skeleton height={344} borderRadius={15} />
                    <Skeleton height={344} borderRadius={15} />
                </div>
            </div>
        </div>
    );
};
